import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, boxImage, offerChecks } from '../data/salesCopy';
export function PricingSection() {
  return <section id="offre" className="scroll-mt-2 bg-brand-brown px-4 py-9 sm:py-12" data-id="element-142" data-mp="1ehyvry0x56mt">
      <div className="mx-auto max-w-2xl text-center" data-id="element-143" data-mp="1j8p2bel2zfj3">
        <p className="inline-block rounded-full bg-brand-gold px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.16em] text-white" data-id="element-144" data-mp="1ja9vp0vnssfd">
          Offre spéciale de lancement
        </p>
        <h2 className="mt-2.5 font-serif text-3xl font-bold uppercase leading-none text-white sm:text-5xl" data-id="element-145" data-mp="1s82b051ds02r">
          🧘 Yin Yoga Pro™
        </h2>
        <p className="mx-auto mt-2 max-w-xl text-[12.5px] font-semibold uppercase leading-snug tracking-wide text-brand-sand sm:text-sm" data-id="element-146" data-mp="227jgalcq0by7">
          Le système visuel complet pour les professeurs de Yin Yoga
        </p>

        <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" className="mt-4 block" data-id="element-147" data-mp="7t0dsis6i8g6">
          <img src={boxImage} alt="Coffret complet YIN YOGA PRO™" className="mx-auto w-full max-w-[240px] sm:max-w-[300px]" data-id="element-148" data-mp="1mgy652ygnos5" />
        </a>

        <div className="mt-4 rounded-xl bg-brand-ivory p-4 text-left sm:p-5" data-id="element-149" data-mp="1cqlllaqnbvm0">
          <p className="text-center text-[12px] font-bold uppercase tracking-wide text-brand-taupe" data-id="element-150" data-mp="1coilfxvs4m3k">
            Système visuel complet 6-en-1
          </p>
          <ul className="mt-2.5 grid grid-cols-1 gap-1.5 sm:grid-cols-2" data-id="element-151" data-mp="25e7rwqr9deck">
            {offerChecks.map(item => <li key={item} className="flex items-start gap-1.5 text-[12.5px] font-semibold leading-snug text-brand-brown" data-id="element-152" data-mp="20h8wm4vuz1cs">
                <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-brand-cta" aria-hidden="true" data-id="element-153" data-mp="1repz80audgxx" />
                {item}
              </li>)}
          </ul>

          <div className="mt-4 border-t border-brand-sand pt-3 text-center" data-id="element-154" data-mp="fzazior90az4">
            <p className="text-[11px] font-bold uppercase tracking-wide text-brand-taupe" data-id="element-155" data-mp="hj2y71r64dgd">
              🔥 Obtenez YIN YOGA PRO™ aujourd’hui
            </p>
            <p className="mt-1 font-serif text-6xl font-bold leading-none text-brand-brown" data-id="element-156" data-mp="7ju6kfjrzax6">
              27<span className="align-top text-2xl" data-id="element-157" data-mp="cioqjkthb5iv">€</span>
            </p>
            <p className="mt-1 text-[11.5px] font-semibold text-brand-taupe" data-id="element-158" data-mp="ckrnypwyo0xm">
              Paiement unique • Accès numérique immédiat
            </p>

            <div className="mt-3 flex justify-center" data-id="element-159" data-mp="3i8jy2hfvi9s">
              <CTAButton href={CHECKOUT_URL} external size="lg" data-id="element-160" data-mp="3jtie36vjlcx">
                🧘 Oui ! Je veux le système complet
              </CTAButton>
            </div>

            <div className="mt-2.5 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-[11px] font-semibold text-brand-taupe" data-id="element-161" data-mp="3pycx60zrh2jx">
              <span data-id="element-162" data-mp="3c067371206ut">🛡️ Garantie satisfait ou remboursé de 7 jours</span>
              <span className="rounded-full bg-brand-sand px-2.5 py-1 text-brand-brown" data-id="element-163" data-mp="3fylzjqfwm7fm">
                🧘 Système complet 6-en-1
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}